// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"ceb6340b","197":"4d97fd4f","221":"93aa6ff4","599":"697d8dca","778":"6fe864fb","787":"b2e6a7ac","801":"cb612ca0","879":"614f27b3","910":"a36eacf1","918":"42f49dca","926":"414ca765"}[chunkId] + ".chunk.js";
};